import { render, staticRenderFns } from "./statementFilter.vue?vue&type=template&id=22cc0ff2&"
import script from "./statementFilter.vue?vue&type=script&lang=js&"
export * from "./statementFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports